import React from "react";
import { UserCertifiedModeInfoModalTemplate } from "themes/application/user-settings/components";

function UserCertifiedModeInfoModal(props) {
    return <UserCertifiedModeInfoModalTemplate {...props} />;
}

export default UserCertifiedModeInfoModal;
